import cloneDeep from 'lodash/cloneDeep';

import { CDFIDMViewMigrator, type Notification } from '@cognite/apm-client';
import type { Filters, Sort } from '@cognite/fdm-client';

import type { NotificationViewMigrator } from './types';

export class NotificationIDMMigrator
  extends CDFIDMViewMigrator
  implements NotificationViewMigrator
{
  /** Instance space where mainAsset (asset) relation is resolved. Defaults to the notification space if not provided. */
  private readonly assetSpace: string;

  constructor(space: string, assetSpace?: string) {
    super(space);
    this.assetSpace = assetSpace ?? space;
  }
  mapDataOutward = (
    data: Record<string, unknown> & {
      externalId: string;
      name: string;
      asset?: { externalId: string };
      sourceCreatedTime: string;
    }
  ): Notification => {
    return {
      ...data,
      externalId: data.externalId,
      title: data.name,
      assetExternalId: data.asset?.externalId,
      createdDate: data.sourceCreatedTime,
    };
  };
  mapFiltersInward = (filters: Filters): Filters => {
    const newFilters = cloneDeep(filters);
    Object.keys(filters).forEach((key) => {
      if (key === 'and') {
        newFilters.and = filters.and!.map((f) => this.mapFiltersInward(f));
      }
      if (key === 'or') {
        newFilters.or = filters.or!.map((f) => this.mapFiltersInward(f));
      }
      if (key === 'not') {
        newFilters.not = this.mapFiltersInward(newFilters.not!);
      }

      if (key === 'equals') {
        if (filters.equals?.property === 'assetExternalId') {
          newFilters.equals = undefined;
          newFilters.directRelationFilter = {
            asset: {
              equals: { property: 'externalId', eq: String(filters.equals.eq) },
            },
          };
          newFilters.directRelationInstanceSpace = this.assetSpace;
        }
      }
    });
    return newFilters;
  };
  mapSortInward = (sort: Sort): Sort => {
    return sort.map((x) => {
      if (Object.keys(x)[0] === 'createdDate') {
        return { sourceCreatedTime: x.createdDate };
      }
      return x;
    });
  };
}

export function createNotificationIDMMigrator(
  ...args: ConstructorParameters<typeof NotificationIDMMigrator>
): NotificationViewMigrator {
  return new NotificationIDMMigrator(...args);
}
